const testimonialsData = [
  {
    id: 1,
    name: 'Leonardo de Andrade',
    title: 'IT Manager',
    img:
        './assets/images/leo.png',
    icon: './assets/linkedin.png',
    desc:
        'Hamza is a self-motivated person with an excellent vision of the process to create the best solutions for any type of problem.',
  },
  {
    id: 2,
    name: 'Nelsino Francisco',
    title: 'Software Engineer',
    img:
        './assets/images/nelsino.png',
    icon: 'assets/twitter.png',
    desc:
        'I love this boy! So easy to work with, always helpful and can always give you insights on how to make your code better you would love to have him as a coding partner',
    featured: true,
  },
  {
    id: 3,
    name: 'Sohaib El Haddad',
    title: 'Ruby on Rails Developer',
    img:
        './assets/images/sohaib.png',
    icon: './assets/linkedin.png',
    desc:
        'I studied with Hamza in the two years preparatory classes after high school, I was always impressed by his dedication to getting the job well done.',
  },
];

export default testimonialsData;
